<template>
  <div v-if="showPros" class="small-margin-bottom-xl large-margin-bottom-xxl" :class="{ 'sr-only-invisible': isLoading }">
    <ProsCollection
      :recommendation-config="{ zone, productId, categoryId, ...facets }"
      :panel-config="{
        componentType: prosCollectionComponentType.PROS_CAROUSEL,
        properties: killswitches,
        showDivider: ref(true),
        customStyleClass: 'custom-zone-unavailable',
        customHeaderType: 'div',
        customRole: 'heading',
        customAriaLevel: '4',
      }"
      @data-load-status-event="loader"
    />
  </div>
  <div v-if="isLoading" class="small-margin-bottom-xl large-margin-bottom-xxl">
    <Skeleton height="450px" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { usePageData } from '~/composables/usePageData';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import useProsLoader from '~/composables/utils/useProsLoader';
import parseFacetsFromUrl from '~/utils/parseUrl';

import Skeleton from '@atomic-ui/skeleton/Skeleton';
import ProsCollection from '@nuxt-common/pros-collection/app/components/ProsCollection.vue';
import prosCollectionComponentType from '@nuxt-common/pros-collection/app/utils/prosCollectionComponentType';

defineProps<{
  zone: string;
}>();

const { taxonomy } = useCommonProductGetters();
const categoryId = taxonomy.defaultCategoryId;

const { productId, killswitches } = usePageData();
const { showPros, loader, isLoading } = useProsLoader({ withFallback: true });
const facets = parseFacetsFromUrl();
</script>

<style lang="scss">
@import '~settingSCSS';
.custom-zone-unavailable {
  .header-container > div:first-child {
    @include header(h4);
  }
}
.sr-only-invisible {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
</style>
